const e = (a) => typeof a == "number" ? a : parseFloat(a);
export {
  e as a
};
//# sourceMappingURL=as-num-DQjLjHSI.js.map
